import { StatusCard, Icon } from "src/components";
import styling from "./NoAccessBlock.module.scss";
import { useTranslation } from "react-i18next";
import { TRANSLATION } from "src/models/constants";
import { Button, Flex } from "@scaleaq/sui-react";

export const NoAccessBlock = () => {
	const { t } = useTranslation([TRANSLATION.COMMON]);

	return (
		<Flex.Column className={styling["wrapper"]} width="100%" height="100%" alignment="center">
			<StatusCard
				title={t("COMMON:noAccess.title")}
				icon={<Icon size="large" name="LargeWarning" />}
				description={t("COMMON:noAccess.message")}
				color={"caution"}
			>
				<Flex.Row alignment="bottom-right" width="100%" className={styling["nav"]} render={<nav />}>
					<Button color="neutral" variant="soft">
						{t("COMMON:log-out")}
					</Button>
				</Flex.Row>
			</StatusCard>
		</Flex.Column>
	);
};
